const zIndices = {
  loader: 100,
  modalRoot: 99,
  drawerRoot: 99,
  preHeader: 99,
  masterHeader: 98,
};

export default zIndices;
